export const light = {
  primary: '#20929D',
  secondary: '#097EEC',
  accent: '#0AB3C8',
  error: '#f44336',
  warning: '#ff9800',
  info: '#d7e0dc',
  success: '#4caf50',
}
